import { RadioGroup } from 'cdk-radial';
import { useIntl, IntlShape } from 'react-intl';
import {
  setPrintOrder,
  getPrinterName,
  getPrintOrder
} from 'pages/VendorsTablePage/components/PrintChecks/slice';
import { useAppSelector, useAppDispatch } from 'store/hooks';
import { labels } from './messages';
import {
  StyledPrintCheckValue,
  StyledPrintOrderDiv,
  StyledPrintCheckLabel,
  StyledPrintContent
} from './styled';

export const PrintOptionsContent = (): React.JSX.Element => {
  const intl: IntlShape = useIntl();
  const dispatch = useAppDispatch();
  const printerName = useAppSelector(getPrinterName);
  const printOrder = useAppSelector(getPrintOrder);

  const radioOptions = [
    {
      id: 'vendorName',
      label: intl.formatMessage(labels.vendorLabel),
      value: 'vendorName'
    },
    {
      id: 'vendorNo',
      label: intl.formatMessage(labels.vendorNumber),
      value: 'vendorNo'
    }
  ];

  const handleOptionSelect = (event: { target: { value: string } }) => {
    const {
      target: { value }
    } = event;
    dispatch(setPrintOrder(value));
  };

  return (
    <>
      <StyledPrintContent>
        <StyledPrintOrderDiv>
          <StyledPrintCheckLabel>
            {intl.formatMessage(labels.printOrderLabel)}
          </StyledPrintCheckLabel>
          <RadioGroup
            className="radioGroup"
            name="printOrder"
            onChange={handleOptionSelect}
            options={radioOptions}
            value={printOrder}
          />
        </StyledPrintOrderDiv>
        <StyledPrintCheckValue>{printerName}</StyledPrintCheckValue>
      </StyledPrintContent>
    </>
  );
};
